declare global {
  interface Window {
    fbq: any
  }
}

export const CHECKOUT_URL_MEGAPACK =
  'https://mega-pack-hombre-magnetico.impultienda.ar/checkout'
export const CHECKOUT_URL_UPSELL =
  'https://mega-pack-hombre-magnetico.impultienda.ar/checkout'

export const handleCheckoutMegapack = (e?: React.MouseEvent) => {
  if (e) {
    e.preventDefault()
  }

  // Fire Meta Pixel InitiateCheckout event
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'InitiateCheckout')
  }

  // Redirect to checkout
  window.location.href = CHECKOUT_URL_MEGAPACK
}

export const handleCheckoutUpsell = (e?: React.MouseEvent) => {
  if (e) {
    e.preventDefault()
  }

  // Fire Meta Pixel InitiateCheckout event
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'InitiateCheckout')
  }

  // Redirect to checkout
  window.location.href = CHECKOUT_URL_UPSELL
}

export const scrollToPurchase = (e?: React.MouseEvent) => {
  if (e) {
    e.preventDefault()
  }
  const el = document.getElementById('purchase')
  if (el) {
    el.scrollIntoView({ behavior: 'smooth', block: 'start' })
  }
}
